import { Link } from '@chakra-ui/react';
import { Link as ReactDomLink } from 'react-router-dom';
import {
  AccountLookupPopover,
  CreditLookupPopover,
  CreditNoteLookupPopover,
  InvoiceLookupPopover,
  PaymentLookupPopover,
  RefundLookupPopover,
} from '../Monetize/LookupPopover';

export function SourceIdCell({ sourceId }: { sourceId: string }) {
  if (sourceId.startsWith('acct')) {
    return <AccountLookupPopover value={sourceId} />;
  }
  if (sourceId.startsWith('invc')) {
    return <InvoiceLookupPopover value={sourceId} />;
  }
  if (sourceId.startsWith('pymt')) {
    return <PaymentLookupPopover value={sourceId} />;
  }
  if (sourceId.startsWith('crdt')) {
    return <CreditLookupPopover value={sourceId} />;
  }
  if (sourceId.startsWith('crnt')) {
    return <CreditNoteLookupPopover value={sourceId} />;
  }
  if (sourceId.startsWith('rfnd')) {
    return <RefundLookupPopover value={sourceId} />;
  }
  return (
    <Link
      fontWeight="400"
      whiteSpace="normal"
      _hover={{ textDecoration: 'underline' }}
      asChild
    >
      <ReactDomLink to={`/${sourceId}`}>{sourceId}</ReactDomLink>
    </Link>
  );
}
